import { render, staticRenderFns } from "./AssessmentDraftResume.vue?vue&type=template&id=2a6bd98d&"
import script from "./AssessmentDraftResume.vue?vue&type=script&lang=js&"
export * from "./AssessmentDraftResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports